import { Input, Typography } from "antd";
import { mapboxSuggests, mapboxSuggestsRetrieve } from "../core/locationFinderService";
import { useEffect, useState } from "react";
import { EnvironmentOutlined } from "@ant-design/icons";
import './SingleLayerSettingsSearch.css'

const { Text, Link } = Typography;

export function SingleLayerSettingsSearch({
    viewState,
    setViewState,
    data
}) {
    const [isFirst, setIsFirst] = useState(true);
    const [searchResults, setSearchResults] = useState([]);

    useEffect(() => {
        if (data['geoserver_layer_name'] === 'morphology-buildings-sumatra') {
            setSearchResults([
                { name: 'Banda Aceh', mapbox_id: 'dXJuOm1ieHBsYzpBb2hu' },
                { name: 'Bandar Lampung', mapbox_id: 'dXJuOm1ieHBsYzpBcWhu' },
                { name: 'Bengkulu', mapbox_id: 'dXJuOm1ieHBsYzpCNGhu' },
                { name: 'Jambi', mapbox_id: 'dXJuOm1ieHBsYzpFb2hu' },
                { name: 'Medan', mapbox_id: 'dXJuOm1ieHBsYzpJVWhu' },
                { name: 'Padang', mapbox_id: 'dXJuOm1ieHBsYzpKaWhu' },
                { name: 'Palembang', mapbox_id: 'dXJuOm1ieHBsYzpKMGhu' },
                { name: 'Pekanbaru', mapbox_id: 'dXJuOm1ieHBsYzpLY2hu' }
            ])
        }
        if (data.id === 38) {
            setSearchResults([
                { name: 'Medan', mapbox_id: 'dXJuOm1ieHBsYzpJVWhu' },
                { name: 'Padang', mapbox_id: 'dXJuOm1ieHBsYzpKaWhu' },
            ])
        }
        if (data['geoserver_layer_name']==='ps-descending-sumatra') {
            setSearchResults([
                { name: 'Medan', mapbox_id: 'dXJuOm1ieHBsYzpJVWhu' },
                { name: 'Palembang', mapbox_id: 'dXJuOm1ieHBsYzpKMGhu' }
            ])
        }
        if (data['geoserver_layer_name']==='ps-ascending-sumatra') {
            setSearchResults([
                { name: 'Medan', mapbox_id: 'dXJuOm1ieHBsYzpJVWhu' },
                { name: 'Palembang', mapbox_id: 'dXJuOm1ieHBsYzpKMGhu' }
            ])
        }
    }, [data.id])

    function handleSearch(value) {

        if (value.length < 3) {
            setSearchResults([])
            return
        }

        mapboxSuggests(value).then((response) => {
            setIsFirst(false)
            setSearchResults(response.data.suggestions)
            // console.log(response.data.suggestions)
        });
    }

    function setLocation(mapbox_id) {

        mapboxSuggestsRetrieve(mapbox_id).then((response) => {

            setViewState({
                ...viewState,
                latitude: response.data.features[0].properties.coordinates.latitude,
                longitude: response.data.features[0].properties.coordinates.longitude,
                zoom: 10,
                transitionDuration: 2000,
                // transitionInterpolator: new FlyToInterpolator()
            })
        })


        // setViewState
    }


    return (
        <div style={{ maxHeight: '100%', overflowY: 'auto' }}>
            <Input
                placeholder="Enter the name of a place"
                onChange={(value) => handleSearch(value.target.value)}
            />

            <div style={{ marginTop: 20 }}>

                {!isFirst && searchResults.length === 0 && <div
                    style={{ padding: 20, margin: "auto", textAlign: "center" }}
                ><Text type="secondary">No results found</Text></div>}

                {searchResults.map((item, index) => <div key={index} className="search-result"
                    onClick={() => setLocation(item.mapbox_id)}
                    style={{ marginBottom: 10 }}>
                    <EnvironmentOutlined /><Text strong
                        className="search-result-name"
                        style={{ marginLeft: 10 }}>{item.name}</Text>
                    <br />
                    <Text type="secondary">{item.place_formatted}</Text>

                </div>
                )}

            </div>
        </div>
    )

}